// FontAwesome normally injects its own <style> tag when the first icon
// renders. On a prerendered page that is too late: the icon SVGs are already
// in the HTML, and with nothing sizing them they paint at their intrinsic
// 512px until hydration runs. Import the stylesheet so it ships in the CSS
// bundle instead, and turn the runtime injection off so it cannot re-add it.
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"

config.autoAddCss = false

// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"
